"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillSplit = exports.Pills = exports.Pill = void 0;
var react_1 = __importDefault(require("react"));
var PillColor;
(function (PillColor) {
    PillColor["Primary"] = "+1";
    PillColor["Secondary"] = "+2";
    PillColor["Quiet"] = "+quiet";
    PillColor["Positive"] = "+pos";
    PillColor["Negative"] = "+neg";
    PillColor["Warning"] = "+warn";
})(PillColor || (PillColor = {}));
var PillType;
(function (PillType) {
    PillType["Ghost"] = "+ghost";
    PillType["Text"] = "+text";
})(PillType || (PillType = {}));
var PillShape;
(function (PillShape) {
    PillShape["Tighter"] = "+tighter";
    PillShape["Tight"] = "+tight";
})(PillShape || (PillShape = {}));
var Pill = function (props) {
    var color = props.color, type = props.type, shape = props.shape, hover = props.hover, noHover = props.noHover, stacked = props.stacked, hasIcon = props.hasIcon, spanProps = __rest(props, ["color", "type", "shape", "hover", "noHover", "stacked", "hasIcon"]);
    var classes = [
        "c-pill",
        color,
        type,
        shape,
        hover ? "+hover" : "",
        noHover ? "+no-hover" : "",
        stacked ? "+stacked" : "",
        hasIcon ? "+icon" : "",
        spanProps.className,
    ].filter(function (value) { return !!value; });
    return react_1.default.createElement("span", __assign({}, spanProps, { className: classes.join(" ") }));
};
exports.Pill = Pill;
var PillText = function (props) {
    return (react_1.default.createElement("span", __assign({}, props, { className: "c-pill__text" + (props.className ? " " + props.className : "") })));
};
var PillIcon = function (props) {
    return (react_1.default.createElement("svg", __assign({}, props, { className: "c-pill__icon c-icon" + (props.className ? " " + props.className : "") })));
};
exports.Pill.Color = PillColor;
exports.Pill.Shape = PillShape;
exports.Pill.Type = PillType;
exports.Pill.Text = PillText;
exports.Pill.Icon = PillIcon;
exports.Pill.displayName = "Pill";
var Pills = function (props) { return (react_1.default.createElement("div", __assign({}, props, { className: "c-pills" + (props.className ? " " + props.className : "") }))); };
exports.Pills = Pills;
exports.Pills.displayName = "Pills";
var PillSplit = function (props) { return (react_1.default.createElement("div", __assign({}, props, { className: "c-pill-split" + (props.className ? " " + props.className : "") }))); };
exports.PillSplit = PillSplit;
exports.PillSplit.displayName = "PillSplit";
//# sourceMappingURL=Pill.js.map